import { RENTAL_PORTAL_FACT_SEPARATOR } from '../../../../constants/rentalPortal'
import {
  getMatchCriterionLabelKey,
  getMatchCriterionStatusText,
  getMatchReasonLabelKey,
} from '../RentalPortalMatch.utils'

export function getMatchCriterionChipTooltip({ criterion, t }) {
  return [
    t(getMatchCriterionLabelKey(criterion.key)),
    getMatchCriterionStatusText({ criterion, t }),
    criterion.reason ? t(getMatchReasonLabelKey(criterion.reason)) : null,
  ]
    .filter(Boolean)
    .join(RENTAL_PORTAL_FACT_SEPARATOR)
}
